import { Button, Container, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";

import { NotFoundLogo } from "../icons";

const StyledContainer = styled(Container)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
});

const StyledLogo = styled(NotFoundLogo)(({ theme }) => ({
  height: "20rem",
  marginBottom: theme.spacing(4),
}));

function NotFound() {
  return (
    <StyledContainer>
      <StyledLogo />
      <Typography variant="h2">404 Not Found</Typography>
      <Typography variant="body1" color="secondary">
        Sorry, we couldn&apos;t find the page you were looking for.
      </Typography>
      <Button
        sx={{
          mt: 4,
        }}
        color="primary"
        variant="contained"
        component={Link}
        to="/"
      >
        Go to Dashboard
      </Button>
    </StyledContainer>
  );
}

export default NotFound;
